var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12" } },
    [
      _c(
        "w-link",
        {
          on: {
            click: function ($event) {
              _vm.isOpened = !_vm.isOpened
            },
          },
        },
        [_vm._v(_vm._s(_vm.toggleText))]
      ),
      _c("w-transition-slide-height", [
        _vm.isOpened
          ? _c(
              "div",
              [
                _c("w-input", {
                  staticClass: "mb",
                  attrs: { label: _vm.$ct("icon-true"), fancy: "" },
                  model: {
                    value: _vm.column.IconTrue,
                    callback: function ($$v) {
                      _vm.$set(_vm.column, "IconTrue", $$v)
                    },
                    expression: "column.IconTrue",
                  },
                }),
                _c("app-color-picker", {
                  staticClass: "mb",
                  attrs: {
                    color: _vm.column.IconTrueColor,
                    label: _vm.$ct("icon-true-color"),
                    fancy: "",
                  },
                  on: {
                    input: function ($event) {
                      _vm.column.IconTrueColor = $event
                    },
                  },
                }),
                _c("w-input", {
                  staticClass: "mb",
                  attrs: { label: _vm.$ct("icon-false"), fancy: "" },
                  model: {
                    value: _vm.column.IconFalse,
                    callback: function ($$v) {
                      _vm.$set(_vm.column, "IconFalse", $$v)
                    },
                    expression: "column.IconFalse",
                  },
                }),
                _c("app-color-picker", {
                  staticClass: "mb",
                  attrs: {
                    color: _vm.column.IconFalseColor,
                    label: _vm.$ct("icon-false-color"),
                    fancy: "",
                  },
                  on: {
                    input: function ($event) {
                      _vm.column.IconFalseColor = $event
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }